import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-icon-info',
    templateUrl: './icon-info.component.html',
    styleUrl: '../icon-shared/icon-shared.scss'
})
export class IconInfoComponent {
    @Input() isActive: boolean = false;
}
